export var IQueryFlashSalesRequest;
(function (IQueryFlashSalesRequest) {
    /**
     * Identifying source sent from clients, used to decide if clearance should be returned
     */
    let SearchSource;
    (function (SearchSource) {
        SearchSource["LANDING_PAGE"] = "LANDING_PAGE";
        SearchSource["CAROUSEL"] = "CAROUSEL";
        SearchSource["SEASONAL_SALE"] = "SEASONAL_SALE";
    })(SearchSource = IQueryFlashSalesRequest.SearchSource || (IQueryFlashSalesRequest.SearchSource = {}));
    /**
     * Return an instance of IQueryFlashSalesRequest with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IQueryFlashSalesRequest.build = (partial) => (Object.assign({ filter_keys: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IQueryFlashSalesRequest || (IQueryFlashSalesRequest = {}));
